var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    _vm._l(_vm.tabs, function(tab) {
      return _c(
        "button",
        {
          key: tab.label,
          staticClass: "btn btn-tab btn-tab-sm",
          class: _vm.selectedTab == tab.value ? "active selected-tab" : "",
          attrs: {
            type: "button",
            disabled: _vm.selectedTab == tab.value ? true : false
          },
          on: {
            click: function($event) {
              return _vm.handleTabChange(tab.value)
            }
          }
        },
        [_vm._v("\n    " + _vm._s(tab.label) + "\n  ")]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }